/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// TODO Need to rebuild this UI?
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Container, Typography } from '@mui/material';
import { NotificationList } from './notificationList';
import { NotificationRepository } from '../../state/reduxRepositories';

import {
  Notification,
  LinkType,
} from '../../state/reduxRepositories/notifications/notification.interfaces';
import styles from './notifications.module.scss';
import { di } from '../../state/inversify.config';
import { ModelTypes } from '../../state/dataStorePersistence/DataStoreModel';
import { Button } from '../../components/button/button';

export function Notifications() {
  const { t } = useTranslation();
  const notificationRepository = di.get<NotificationRepository>(
    NotificationRepository,
  );

  const setNotificationRead = (notificationId: string) => {
    notificationRepository.dispatchUpdate({ id: notificationId, read: true });
  };

  const notifications = notificationRepository.useResourcesSelector();
  const [activeTab, setActiveTab] = useState('unread');
  const [statusText, setStatusText] = useState('');

  useEffect(() => {
    let newStatus = '';
    if (notifications.length === 0)
      newStatus = t('notification.NO_NOTIFICATIONS');
    else {
      const noApplicableNotifications =
        notifications.filter((n) => {
          return (
            (activeTab === 'read' && n.read) ||
            (activeTab === 'unread' && !n.read)
          );
        }).length === 0;

      if (noApplicableNotifications) {
        if (activeTab === 'read')
          newStatus = t('notification.NO_READ_NOTIFICATIONS');
        if (activeTab === 'unread')
          newStatus = t('notification.NO_UNREAD_NOTIFICATIONS');
      }
    }

    setStatusText(newStatus);
  }, [activeTab, notifications, t]);

  return (
    <Container>
      {false /* uncomment to test adding a notification */ && (
        <Button
          onClick={() => {
            const newNotification: Partial<Notification> = {
              accountId: '1234',
              modelType: ModelTypes.Notification,
              createdByUserId: '',
              mainText: 'Someone had a thing booked. Click to view player',
              notificationTime: new Date().toISOString(),
              linkType: LinkType.player,
              linkId: '935d7a0f-16fe-4d48-b0c2-fae51983d665',
              // linkId: '',
              read: false,
            };
            console.log('With create a notification');
            notificationRepository.dispatchCreate(newNotification);
            console.log('Called dispatch');
          }}
          color="secondary"
          label="Add Notification"
          variant="text"
          type="submit"
        />
      )}

      <Typography variant="h5" fontWeight="600">
        {t('notification.NOTIFICATIONS')}
      </Typography>
      <div className={styles.tabs}>
        <div
          onClick={() => setActiveTab('unread')}
          className={clsx(styles.tab, activeTab === 'unread' && styles.active)}
        >
          <span>{t('notification.UNREAD')}</span>
        </div>
        <div
          onClick={() => setActiveTab('read')}
          className={clsx(styles.tab, activeTab === 'read' && styles.active)}
        >
          <span>{t('notification.READ')}</span>
        </div>
      </div>
      <div>
        {statusText ? (
          <div className={styles.statusText}>{statusText}</div>
        ) : null}
        <NotificationList
          setAsRead={setNotificationRead}
          notifications={
            notifications
              .filter((n) => {
                return (
                  (activeTab === 'read' && n.read) ||
                  (activeTab === 'unread' && !n.read)
                );
              })
              .map((n: Notification) => {
                return {
                  id: n.id,
                  mainText: n.mainText || '',
                  notificationTime: new Date(n.createdAt),
                  linkType: n.linkType,
                  linkId: n.linkId,
                  read: n.read,
                };
              })

            //   [
            //   {
            //     id: '123',
            //     imageSource: 'test',
            //     mainText:
            //       "this is some main text here. But what's it about exactly? Doesn't matter, takes up the space.",
            //     notificationTime: new Date(2022, 0, 10, 10, 10, 10),
            //     linkType: LinkType.conneqt,
            //     linkId: 'abcdef',
            //     read: false,
            //   },
            //   {
            //     id: '1234',
            //     imageSource: 'test',
            //     mainText: 'this is some main text here',
            //     notificationTime: new Date(),
            //     linkType: LinkType.conneqt,
            //     linkId: 'abcdef',
            //     read: true,
            //   },
            // ]}
          }
        />
      </div>
    </Container>
  );
}
